import {
    ForumFeedInfiniteListState,
    ForumFeedPageState,
    OrderBy,
} from 'mk2/apps/forum/containers/ForumFeed/ForumFeed.reducers';
import { AppState } from 'mk2/reducers';
import { initialState } from 'mk2/reducers/infiniteList';

export const getForumFeedPageState = (state: AppState): ForumFeedPageState =>
    state.containers.forum.forumFeed;

export const getForumFeedInfiniteListState = (state: AppState, orderBy: OrderBy): ForumFeedInfiniteListState =>
    getForumFeedPageState(state).orders[orderBy] || initialState;
